import React, { Component } from "react";
import moment from "moment";

import { getMailing } from "../../utils/operations.js";
import { observer, inject } from "mobx-react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import API from '../../utils/api'
import {toast} from "react-toastify";


class InvoiceSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      textSubject: "",
      textMail: "",
      organisation_id: 1,
      newDay: "",
      newTime: ""
    };
  }

  componentDidMount() {
    if (!this.props.Auth.can('invoiceschedule')) { this.props.history.push("/children"); return; }
    this.props.Auth.snackBar = false;
    this.loadData();
  }

  loadData = async () => {
    let res = await API.get(getMailing);

    this.setState({ data: res.data.resource });
  };

  getHours = time => {
    if (!time) return 0;

    let hour = time.split(":");
    return Number(hour[0]);
  };

  getMinutes = time => {
    if (!time) return 0;

    let minutes = time.split(":");
    return Number(minutes[1]);
  };

  handleSubject = event => {
    let index = Number(event.target.id);
    const data = this.state.data;
    data[index].subject = event.target.value;

    this.setState({ data });
  };

  handleText = event => {
    let index = Number(event.target.id);
    const data = this.state.data;
    data[index].text = event.target.value;

    this.setState({ data });
  };

  changeDay = (index, value) => {
    let data = this.state.data;
    data[index].day = value;
    this.setState({ data });
  };

  handleTime = index => (newValue) => {
    let data = this.state.data;
    data[index].time = moment(newValue).format("HH:mm:ss");
  };

  handleFee = (index, value) => {
    const data = this.state.data;
    data[index].apply_fee = value;

    this.setState({ data });
  };

  saveData = async (id) => {
    try {
      const mailingToChange = this.state.data.find(m => m.id === id)
      await API.patch(getMailing, { resource: [mailingToChange] })
      toast.success('The Schedule "' + mailingToChange.subject + '" was changed successfully.')
    } catch (e) {
      toast.error("Something wrong.")
    }
  };

  render() {
    const daysInMonth = moment().daysInMonth();
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div style={{ maxWidth: 800, margin: "auto" }}>
          {this.state.data.map((row, index) => (
            <div key={index} style={{ margin: "auto", border: '1px solid lightgrey', padding: '20px', borderRadius: '10px', marginBottom: '10px' }}>
              <div>
                <TextField
                  id={index.toString()}
                  label="Mail Subject"
                  fullWidth
                  value={row.subject}
                  onChange={this.handleSubject}
                  sx={{ mb: 2 }}
                />
              </div>
              {row.is_scheduled && <div style={{display: "flex", flex: 1, flexDirection: "row"}}>
                <div style={{flex: 1}}>
                  <span style={{color: "gray"}}>Select day:</span>
                  <br/>
                  <FormControl sx={{ minWidth: 80 }}>
                    <InputLabel>Day</InputLabel>
                    <Select
                      label="Day"
                      value={row.day || ''}
                      onChange={(e) => this.changeDay(index, e.target.value)}
                    >
                      {days.map(d => (
                        <MenuItem value={d} key={d}>{d}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div style={{flex: 1}}>
                  <span style={{color: "gray"}}>Select time:</span>
                  <br/>
                  <TimePicker
                    value={
                      new Date(
                        2019, 1, 1,
                        this.getHours(row.time),
                        this.getMinutes(row.time),
                        0, 0
                      )
                    }
                    minutesStep={5}
                    onChange={this.handleTime(index)}
                    slotProps={{ textField: {} }}
                  />
                </div>
                {(row.id > 1) && <div style={{flex: 1}}>
                  <span style={{color: "gray"}}>Apply Fee:</span>
                  <br/>
                  <div style={{paddingTop: '24px'}}>
                    <FormControlLabel
                      control={
                        <Switch
                          defaultChecked={!!row.apply_fee}
                          onChange={(event) => this.handleFee(index, event.target.checked)}
                        />
                      }
                      label=""
                    />
                  </div>
                </div>}
              </div>}
              <div>
                <TextField
                  id={index.toString()}
                  name={String(row.id)}
                  label="Mailing Text"
                  fullWidth
                  multiline
                  rows={4}
                  maxRows={10}
                  value={row.text}
                  onChange={this.handleText}
                  sx={{ mt: 2, mb: 2 }}
                />
              </div>
              <Button variant="contained" color="primary" onClick={() => this.saveData(row.id)}>Save</Button>
            </div>
          ))}
        </div>
      </LocalizationProvider>
    );
  }
}

export default inject("Auth")(observer(InvoiceSchedule))
